module.exports = {
  "dof-colmo-tag": {
    "paddingTop": "8",
    "paddingRight": "16",
    "paddingBottom": "8",
    "paddingLeft": "16",
    "borderWidth": "1",
    "borderStyle": "solid",
    "lineHeight": "24"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-f0577fe8!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-colmo-tag/index.vue
// module id = 558
// module chunks = 0 1